import { useCallback } from "react";
import { getHost } from "../../host/getHost";

// Bulk-license route on the presenter side. The host receives this path
// via onRouteChange and pushes its own router — same-tab navigation,
// embed unmounts when the parent leaves the My Team page.
const BULK_LICENSE_PATH = "/apps/user-plan#bulk-pricing";

// Standalone dev fallback only — when the embed runs outside zoid we
// can't ask the host to navigate, so we open the presenter directly.
const PRESENTER_DOMAIN: string | undefined = import.meta.env.VITE_PRESENTER_DOMAIN;

export function useGoToBulkLicensePage(): () => void {
  return useCallback(() => {
    const host = getHost();
    if (host?.onRouteChange) {
      host.onRouteChange({
        location: BULK_LICENSE_PATH,
        navType: "push",
        fullScreen: false,
      });
      return;
    }
    if (PRESENTER_DOMAIN) {
      window.open(
        `${PRESENTER_DOMAIN.replace(/\/$/, "")}${BULK_LICENSE_PATH}`,
        "_blank",
        "noopener",
      );
    }
  }, []);
}
